import {defineStore} from 'pinia';
import {opinionStore} from "@/store/opinionStore";
import {argumentStore} from "@/store/argumentStore";

export const shareStore = defineStore('shareStore', {
    state: () => ({
        sharedEntity: null,
        shareModalState: false,
        selectShareEntityModalState: false
    }),
    getters: {

    },
    actions: {
        getShareUrl() {
            const baseUrl = window.location.origin;
            let sharedUrl = '';

            if (this.sharedEntity === 'PROPOSAL') {
                sharedUrl = `${baseUrl}/proposal/${opinionStore().currentOpinion.proposalIds[0]}`;
            } else if (this.sharedEntity === 'OPINION') {
                sharedUrl = `${baseUrl}/opinion/${opinionStore().currentOpinion.opinionNumber}`;
            } else if (this.sharedEntity === 'ARGUMENT') {
                sharedUrl = `${baseUrl}/argument/${argumentStore().activeArgument.id}`;
            } else {
                sharedUrl = window.location.href;
            }

            return sharedUrl;
        },
        setShareEntityType(type) {
            this.sharedEntity = type;
        },
        toggleShareModal() {
            this.shareModalState = !this.shareModalState;
        },
        toggleSelectShareEntityModal() {
            this.selectShareEntityModalState = !this.selectShareEntityModalState;
        },
    }
});